import { Injectable } from '@angular/core';
import { Modelogeneral } from '../models/modelogeneral';
import { Login } from '../models/login';
import html2canvas from 'html2canvas';
import { Share } from '@capacitor/share';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';
import { Metodosui } from './metodosui';

@Injectable({
  providedIn: 'root'
})
export class MetodosgenService {

  constructor(private metodosUi: Metodosui) { }

  /**
   * Captura cualquier elemento del DOM por su ID en formato imagen (PNG)
   * y abre el menú de compartir nativo o descarga la imagen en el navegador.
   */
  async exportarElementoComoImagen(elementOrId: string | HTMLElement, titulo: string = 'Resumen', subtitulo: string = ''): Promise<boolean> {
    await this.metodosUi.showLoading('Generando imagen...', 'blue');
    let tempDiv: HTMLElement | null = null;
    try {
      const exportElement = typeof elementOrId === 'string'
        ? document.getElementById(elementOrId)
        : elementOrId;

      if (!exportElement) {
        await this.metodosUi.hideLoading();
        this.metodosUi.showToast('No se encontró el elemento a exportar', 'warning');
        return false;
      }

      // ── Clonación temporal a document.body para evitar fallos de iframe en Ionic ──
      const targetWidth = exportElement.getBoundingClientRect().width || exportElement.offsetWidth || 380;
      tempDiv = exportElement.cloneNode(true) as HTMLElement;
      tempDiv.style.position = 'fixed';
      tempDiv.style.left = '-9999px';
      tempDiv.style.top = '0';
      tempDiv.style.width = `${targetWidth}px`;
      tempDiv.style.height = 'auto';
      tempDiv.style.maxHeight = 'none';
      tempDiv.style.overflow = 'visible';
      tempDiv.style.background = '#f8fafc';
      tempDiv.style.zIndex = '-9999';
      document.body.appendChild(tempDiv);

      // Opciones para html2canvas sobre el contenedor aislado
      const canvas = await html2canvas(tempDiv, {
        scale: 2, // Resolución nítida 2x
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#f8fafc',
        logging: false
      });

      const base64Image = canvas.toDataURL('image/png');
      const base64Raw = base64Image.split(',')[1];
      const cleanSub = (subtitulo || 'resumen').replace(/[^a-zA-Z0-9]/g, '_').toLowerCase();
      const fileName = `export_${cleanSub}_${Date.now()}.png`;

      if (Capacitor.isNativePlatform()) {
        const savedFile = await Filesystem.writeFile({
          path: fileName,
          data: base64Raw,
          directory: Directory.Cache
        });

        await this.metodosUi.hideLoading();

        await Share.share({
          title: titulo,
          text: subtitulo,
          url: savedFile.uri,
          dialogTitle: 'Compartir Imagen'
        });
      } else {
        await this.metodosUi.hideLoading();

        // Web: Si el navegador soporta Web Share API con archivos
        if (navigator.share && navigator.canShare) {
          try {
            const blob = await (await fetch(base64Image)).blob();
            const file = new File([blob], fileName, { type: 'image/png' });
            if (navigator.canShare({ files: [file] })) {
              await navigator.share({
                title: titulo,
                text: subtitulo,
                files: [file]
              });
              return true;
            }
          } catch (shareErr) {
            console.warn('Fallback a descarga:', shareErr);
          }
        }

        // Fallback de descarga directa en navegador
        const link = document.createElement('a');
        link.href = base64Image;
        link.download = fileName;
        link.click();
        this.metodosUi.showToast('Imagen descargada correctamente', 'success');
      }
      return true;
    } catch (error) {
      console.error('Error al exportar imagen:', error);
      await this.metodosUi.hideLoading();
      this.metodosUi.showToast('Error al generar la imagen', 'danger');
      return false;
    } finally {
      if (tempDiv && document.body.contains(tempDiv)) {
        document.body.removeChild(tempDiv);
      }
      await this.metodosUi.hideLoading();
    }
  }

  getUsuario(): string {
    const userJson = localStorage.getItem('user');
    if (userJson) {
      const user = JSON.parse(userJson);
      return user.l_usuario || "";
    }
    return "";
  }

  isSuperAdmin(): boolean {
    const userJson = localStorage.getItem('user');
    if (!userJson) return false;
    try {
      const user = JSON.parse(userJson);
      return (user.l_rol_nombre || '').toUpperCase() === 'SUPERADMIN';
    } catch (e) {
      return false;
    }
  }

  setModeloGeneral(
    irutina: string,
    isubrutina: string,
    idt1: string,
    idt2: string,
    idt3: string,
    idt4: string,
    idt5: string,
    idt6: string,
    idt7: string,
    idt8: string,
    idt9: string,
    idt10: string,
    idt11: string,
    idt12: string,
    idt13: string,
    idt14: string,
    idt15: string
  ): Modelogeneral {
    let currentUser = "";
    const userJson = localStorage.getItem('user');
    if (userJson) {
      const user = JSON.parse(userJson);
      currentUser = user.l_usuario || "";
    }

    return {
      empresa: 'pgarcia2',
      rutina: irutina ?? '',
      subrutina: isubrutina ?? '',
      usuario: currentUser,
      datos: {
        dt1: idt1 ?? '',
        dt2: idt2 ?? '',
        dt3: idt3 ?? '',
        dt4: idt4 ?? '',
        dt5: idt5 ?? '',
        dt6: idt6 ?? '',
        dt7: idt7 ?? '',
        dt8: idt8 ?? '',
        dt9: idt9 ?? '',
        dt10: idt10 ?? '',
        dt11: idt11 ?? '',
        dt12: idt12 ?? '',
        dt13: idt13 ?? '',
        dt14: idt14 ?? '',
        dt15: idt15 ?? ''
      }
    };
  }

  loadMore(sourceArray: any[], currentDisplayed: any[], step: number = 10): any[] {
    const currentLength = currentDisplayed.length;
    const nextBatch = sourceArray.slice(currentLength, currentLength + step);
    return [...currentDisplayed, ...nextBatch];
  }

  getPermissions(): any {
    const userJson = localStorage.getItem('user');
    if (!userJson) return {};
    try {
      const user = JSON.parse(userJson);

      // MODO DIOS: Si el rol es 'SUPERADMIN', tiene acceso a TODO por siempre.
      if ((user.l_rol_nombre || '').toUpperCase() === 'SUPERADMIN') {
        const createRecursiveProxy = (): any => {
          return new Proxy({}, {
            get: (target, prop: string) => {
              if (prop === 'toJSON') return () => ({});
              if (prop === 'toString') return () => 'true';
              if (typeof prop === 'string' && prop.startsWith('rl_')) {
                return true;
              }
              return createRecursiveProxy();
            }
          });
        };
        return createRecursiveProxy();
      }

      if (user.l_permisos) {
        return typeof user.l_permisos === 'string' ? JSON.parse(user.l_permisos) : user.l_permisos;
      }

      // ESTRATEGIA DE BYPASS: Si el backend es remoto y no tiene el campo l_permisos,
      // buscamos dentro del objeto l_jmenu (columna 8 "hijackeada" en el SP).
      if (user.l_jmenu && user.l_jmenu.permissions) {
        return user.l_jmenu.permissions;
      }

      // Si l_jmenu es string (raro a este punto), intentamos parsearlo
      if (typeof user.l_jmenu === 'string' && user.l_jmenu.includes('"permissions"')) {
        try {
          const menuData = JSON.parse(user.l_jmenu);
          if (menuData.permissions) return menuData.permissions;
        } catch (e) { }
      }

    } catch (e) {
      console.error('Error parsing permissions', e);
    }
    return {};
  }

  /**
   * Procesa un template reemplazando tokens como $id, $lugar o $U-lugar.
   * @param template Texto con variables ($id, $lugar, etc.)
   * @param data Objeto con los valores reales
   * @returns Texto procesado
   */
  processTemplate(template: string, data: any): string {
    if (!template || !data) return template;

    // Regex: busca $ seguido opcionalmente de U- y luego el nombre de la propiedad (permite guiones para cot-id/trab-id)
    return template.replace(/\$([U]-)?([a-zA-Z0-9_-]+)/g, (match, isUpper, key) => {
      let value = '';

      // Caso especial: $horario
      if (key.toLowerCase() === 'horario') {
        const hour = new Date().getHours();
        let greeting = '';
        if (hour >= 0 && hour < 12) greeting = 'Buenos días';
        else if (hour >= 12 && hour < 18) greeting = 'Buenas tardes';
        else greeting = 'Buenas noches';
        value = greeting;
      } else {
        value = data[key] !== undefined && data[key] !== null ? data[key] : '';
      }

      if (isUpper) {
        value = String(value).toUpperCase();
      }
      return value;
    });
  }

  /**
   * Parsea de forma ultra-robusta la respuesta en texto de la IA.
   * Si JSON.parse falla (por comillas internas, caracteres de control, etc.),
   * rescata los campos de forma defensiva mediante Regex.
   * @param rawResult Texto en crudo devuelto por la IA
   * @returns Objeto con los datos extraídos
   */
  parsearJsonIa(rawResult: string): any {
    if (!rawResult) return null;

    let cleanResult = rawResult.trim();

    // 1. Quitar bloques de código Markdown (```json ... ```)
    if (cleanResult.startsWith('```json')) {
      cleanResult = cleanResult.substring(7);
    } else if (cleanResult.startsWith('```')) {
      cleanResult = cleanResult.substring(3);
    }
    if (cleanResult.endsWith('```')) {
      cleanResult = cleanResult.substring(0, cleanResult.length - 3);
    }
    cleanResult = cleanResult.trim();

    // 2. Extraer lo que esté entre la primera llave '{' y la última llave '}'
    const firstBrace = cleanResult.indexOf('{');
    const lastBrace = cleanResult.lastIndexOf('}');
    if (firstBrace !== -1 && lastBrace !== -1 && lastBrace > firstBrace) {
      cleanResult = cleanResult.substring(firstBrace, lastBrace + 1);
    }

    // 3. Limpieza de caracteres de control e invisibles
    const sanitizedResult = cleanResult
      .replace(/[\u0000-\u001F\u007F-\u009F]/g, "") // Remueve caracteres de control
      .replace(/\/\/.*$/gm, "")                     // Remueve comentarios de una línea
      .replace(/\/\*[\s\S]*?\*\//g, "");            // Remueve comentarios multilinea

    // Intentar parsear el JSON limpio directamente
    try {
      return JSON.parse(sanitizedResult);
    } catch (parseErr) {
      console.warn('Error parseando JSON devuelto por la IA. Aplicando extracción defensiva de campos por Regex:', parseErr);
    }

    // Fallback: extracción de campos por Regex
    const data: any = {};

    // --- MONTO ---
    const montoRegex = /"(?:monto|total|monto_total|amount|montoTotal)"\s*:\s*"?([0-9]+[.,]?[0-9]*)"?/i;
    const montoMatch = sanitizedResult.match(montoRegex);
    if (montoMatch) {
      const numStr = montoMatch[1].replace(',', '.');
      data.monto = Number(numStr);
    } else {
      const genericMontoRegex = /(?:total|monto|monto_total|importo|amount)\D+([0-9]+[.,]?[0-9]*)/i;
      const genericMontoMatch = sanitizedResult.match(genericMontoRegex);
      if (genericMontoMatch) {
        const numStr = genericMontoMatch[1].replace(',', '.');
        data.monto = Number(numStr);
      }
    }

    // --- FECHA ---
    const fechaRegex = /"(?:fecha|date|fecha_factura|fechaFactura)"\s*:\s*"([^"]+)"/i;
    const fechaMatch = sanitizedResult.match(fechaRegex);
    if (fechaMatch) {
      data.fecha = fechaMatch[1];
    } else {
      const genericFechaRegex = /\b(\d{4}[-/]\d{2}[-/]\d{2}|\d{2}[-/]\d{2}[-/]\d{4})\b/;
      const genericFechaMatch = sanitizedResult.match(genericFechaRegex);
      if (genericFechaMatch) {
        data.fecha = genericFechaMatch[1];
      }
    }

    // --- DESCRIPCION / DETALLE ---
    const descRegex = /"(?:descripcion|description|items|detalle)"\s*:\s*"([\s\S]*?)"(?=\s*(?:,|\}))/i;
    const descMatch = sanitizedResult.match(descRegex);
    if (descMatch) {
      data.descripcion = descMatch[1].trim();
    } else {
      const genericDescRegex = /"(?:descripcion|description|items|detalle)"\s*:\s*\[([\s\S]*?)\]/i;
      const genericDescMatch = sanitizedResult.match(genericDescRegex);
      if (genericDescMatch) {
        data.descripcion = genericDescMatch[1].trim();
      }
    }

    // --- LUGAR / COMERCIO ---
    const lugarRegex = /"(?:lugar|comercio|vendor|place|establishment)"\s*:\s*"([\s\S]*?)"(?=\s*(?:,|\}))/i;
    const lugarMatch = sanitizedResult.match(lugarRegex);
    if (lugarMatch) {
      data.lugar = lugarMatch[1].trim();
    }

    return data;
  }
}

